import { Card, CardHeader, CardContent } from '#app/components/ui/card.tsx'

const PrivacyPolicy = () => {
	return (
		<Card>
			<CardHeader>
				<h1 className="text-xl font-heading leading-none tracking-tight">
					Privacy Policy
				</h1>
			</CardHeader>
			<CardContent>
				<div className="prose max-w-full">
					<p>
						<strong>Effective Date:</strong> 10th January 2025
					</p>
					<p>
						At ReactionVideos.xyz, your privacy is a top priority. This Privacy
						Policy outlines how we collect, use, and protect your personal
						information when you use our website.
					</p>

					<h2 className="text-lg">Information We Collect</h2>
					<ul>
						<li>
							<strong>Account Information:</strong> When you sign up, we collect
							your username, email address, and password (stored securely in
							hashed form).
						</li>
						<li>
							<strong>User-Generated Content:</strong> Videos you submit, votes,
							and any other content you contribute to the site.
						</li>
						<li>
							<strong>Automatically Collected Information:</strong> We may
							collect non-identifiable data such as IP address, browser type,
							and usage statistics via cookies or similar technologies.
						</li>
					</ul>

					<h2 className="text-lg">How We Use Your Information</h2>
					<ul>
						<li>To create and manage your account.</li>
						<li>To allow you to submit and vote on videos.</li>
						<li>To improve and personalize your experience on the site.</li>
						<li>To monitor site performance and prevent fraud or abuse.</li>
					</ul>

					<h2 className="text-lg">Sharing Your Information</h2>
					<p>
						We do not sell or share your personal information with third parties
						except as required:
					</p>
					<ul>
						<li>To comply with legal obligations.</li>
						<li>To prevent fraud or abuse.</li>
						<li>
							With service providers who help operate the website (e.g.,
							hosting, analytics).
						</li>
					</ul>

					<h2 className="text-lg">Cookies</h2>
					<p>
						We use cookies to enhance your browsing experience. You can disable
						cookies in your browser settings, but some site functionality may be
						affected.
					</p>

					<h2 className="text-lg">Data Security</h2>
					<p>
						We implement industry-standard measures to protect your information.
						However, no method of online storage or transmission is 100% secure.
					</p>

					<h2 className="text-lg">Your Rights</h2>
					<ul>
						<li>
							<strong>Access and Update:</strong> You can access and update your
							account information at any time.
						</li>
						<li>
							<strong>Delete Account:</strong> You may request account deletion
							by contacting us at hello@reactionvideos.xyz.
						</li>
						<li>
							<strong>Cookies:</strong> Manage cookie preferences through your
							browser settings.
						</li>
					</ul>

					<h2 className="text-lg">Changes to This Policy</h2>
					<p>
						We may update this Privacy Policy from time to time. Changes will be
						posted on this page with an updated "Effective Date."
					</p>

					<h2 className="text-lg">Contact Us</h2>
					<p>
						For questions about this Privacy Policy, please contact us at
						hello@reactionvideos.xyz.
					</p>
				</div>
			</CardContent>
		</Card>
	)
}

export default PrivacyPolicy
